import { createContext, ComponentChildren, FunctionalComponent } from 'preact';
import { useContext, useState, useEffect, useMemo } from 'preact/hooks';
import { logger } from '@accedo/logger';

export interface MenuProviderProps {
  children?: ComponentChildren;
}

export interface MenuContext {
  isVisible: boolean;
  show: () => void;
  hide: () => void;
}

const defaultMenuContext: MenuContext = {
  isVisible: false,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  show: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  hide: () => {},
};

export const MenuContext = createContext<MenuContext>(defaultMenuContext);

export const MenuProvider: FunctionalComponent = ({ children }) => {
  const [menuValue, setMenuValue] = useState<MenuContext>({
    ...defaultMenuContext,
  });

  const contextValue: MenuContext = useMemo(
    () => ({
      isVisible: menuValue.isVisible,
      show: () => {
        !menuValue.isVisible && setMenuValue((prev) => ({ ...prev, isVisible: true }));
      },
      hide: () => {
        menuValue.isVisible && setMenuValue((prev) => ({ ...prev, isVisible: false }));
      },
    }),
    [menuValue, setMenuValue],
  );
  return <MenuContext.Provider value={{ ...contextValue }}>{children}</MenuContext.Provider>;
};

export const useMenu = (menuVisible?: boolean): MenuContext => {
  const { show, hide, isVisible } = useContext(MenuContext);

  useEffect(() => {
    logger.debug(`[useMenu] useEffect menuVisible ${menuVisible}`);
    if (menuVisible) {
      show();
    } else {
      hide();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuVisible]);

  return {
    show,
    hide,
    isVisible,
  };
};
